import {
  Alert,
  Button,
  Form,
  FormControl,
  InputGroup,
  Modal,
} from "react-bootstrap";
import { useEffect, useState } from "react";
import { useAuth } from "../../providers/authprovider";

const ROLE_LABELS = {
  USER: "Pracownik",
  MANAGER: "Kierownik",
  ADMIN: "Administrator",
};

export default function AddWorkerModal(props) {
  const { users } = useAuth();
  const departments = props.departments || [];
  const [formData, setFormData] = useState(() =>
    props.worker !== undefined
      ? props.worker
      : {
          name: "",
          email: "",
          tel: "",
          position: "",
          login: "",
          password: "",
          contractor: 0,
          verifyWithSms: 1,
          department: "",
          role: "USER",
        },
  );
  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });
  const [validated, setValidate] = useState(false);
  const [alert, setAlert] = useState({
    show: false,
    content: "",
    variant: "",
    title: "",
  });

  const [signatureUrl, setSignatureUrl] = useState("");
  const EDITION = props.worker !== undefined;

  useEffect(() => {
    if (props.worker?.id)
      users.getSignature(props.worker.id, ({ success, error, content }) => {
        if (!success) return;

        setSignatureUrl(URL.createObjectURL(content));
      });
  }, [props.worker]);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    if (form.checkValidity() === true) {
      const data = new FormData();

      Object.keys(formData).forEach((key) => {
        data.append(key, formData[key]);
      });

      if (form.signatureFile.files.length > 0) {
        data.append("file", form.signatureFile.files[0]);
      }

      users.add(data, EDITION, (response) => {
        if (response.success === true && props.onSave)
          props.onSave(response.content);

        if (response.success === false)
          setAlert({
            show: true,
            content: response.error,
            variant: "warning",
            title: "Błedne dane",
          });
      });
    }

    setValidate(true);
  };

  const hideAlert = () => {
    setAlert({
      show: false,
      content: "",
      variant: "",
      title: "",
    });
  };

  const handleChangeFileInput = (event) => {
    setSignatureUrl(window.URL.createObjectURL(event.target.files[0]));
  };

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      {formData && (
        <Form
          action={"post"}
          onSubmit={handleSubmit}
          noValidate
          validated={validated}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Dodaj pracownika
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Alert
              show={alert.show}
              variant={alert.variant}
              onClose={hideAlert}
              dismissible
            >
              <p>{alert.content}</p>
            </Alert>
            <InputGroup className="mb-3">
              <InputGroup.Text className={"w-25"} id="name">
                Imię i nazwisko
              </InputGroup.Text>
              <FormControl
                required
                name={"name"}
                value={formData.name}
                placeholder="imię i nazwisko"
                aria-label="imie i nazwisko"
                onChange={handleChange}
              />
              <Form.Control.Feedback type="invalid">
                Imię i nazwisko pracownika są wymagane
              </Form.Control.Feedback>
            </InputGroup>
            <InputGroup className="mb-3">
              <InputGroup.Text className={"w-25"} id="login">
                Login
              </InputGroup.Text>
              <FormControl
                required
                name={"login"}
                defaultValue={formData.login}
                placeholder="Login"
                aria-label="Login"
                onChange={handleChange}
                minLength={4}
              />
              <Form.Control.Feedback type="invalid">
                Wprowadź login pracownika, minimum 5 liter.
              </Form.Control.Feedback>
            </InputGroup>
            <InputGroup className="mb-3">
              <InputGroup.Text className={"w-25"} id="password">
                Hasło
              </InputGroup.Text>
              <FormControl
                required={!EDITION}
                name={"password"}
                placeholder="hasło pracownika"
                aria-label="hasło"
                onChange={handleChange}
                minLength={8}
              />
              <Form.Control.Feedback type="invalid">
                Hasło musi się składać z 8 znaków, małych i dużych liter oraz
                cyfry.
              </Form.Control.Feedback>
            </InputGroup>
            <InputGroup className="mb-3">
              <InputGroup.Text className={"w-25"} id="email">
                Adres email
              </InputGroup.Text>
              <FormControl
                onChange={handleChange}
                type={"email"}
                name={"email"}
                defaultValue={formData.email}
                placeholder="email"
              />
            </InputGroup>
            <InputGroup className="mb-3">
              <InputGroup.Text className="w-25" id="tel">
                Numer tel
              </InputGroup.Text>

              <FormControl
                onChange={handleChange}
                type="text"
                name="tel"
                defaultValue={formData.tel}
                placeholder="numer telefonu"
              />

              <InputGroup.Text className="bg-white">
                <Form.Check
                  type="checkbox"
                  id="verifyWithSms"
                  label="Weryfikacja SMS"
                  checked={formData.verifyWithSms == 1}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      verifyWithSms: e.target.checked ? 1 : 0,
                    })
                  }
                />
              </InputGroup.Text>
            </InputGroup>
            <InputGroup className="mb-3">
              <InputGroup.Text className={"w-25"} id="department">
                Oddział
              </InputGroup.Text>
              <Form.Select
                name={"department"}
                value={formData.department || ""}
                onChange={handleChange}
              >
                <option value="">- wybierz oddział -</option>
                {departments.map((department) => (
                  <option key={department.code} value={department.code}>
                    {department.name}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
            <InputGroup className="mb-3">
              <InputGroup.Text className={"w-25"} id="role">
                Rola
              </InputGroup.Text>
              <Form.Select
                name={"role"}
                value={formData.role || "USER"}
                onChange={handleChange}
              >
                {Object.keys(ROLE_LABELS).map((role) => (
                  <option key={role} value={role}>
                    {ROLE_LABELS[role]}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
            <InputGroup className="mb-3">
              <InputGroup.Text className={"w-25"} id="tel">
                Stanowisko
              </InputGroup.Text>
              <FormControl
                onChange={handleChange}
                type={"text"}
                name={"position"}
                defaultValue={formData.position}
                placeholder="stanowisko"
              />
            </InputGroup>
            <Form.Group className="mb-3" controlId="user_signature1">
              <Form.Label>Status pracownika</Form.Label>
              <Form.Check
                type={"checkbox"}
                name={"active"}
                className="ms-4"
                checked={formData.active === 1}
                onChange={(e) =>
                  setFormData({ ...formData, active: e.target.checked ? 1 : 0 })
                }
                label={formData.active === 1 ? "Aktywny" : "Nie aktywny"}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="user_signature1">
              <Form.Label>Podpis pracownika</Form.Label>
              <FormControl
                type={"file"}
                accept={"image/jpeg,image/gif,image/png"}
                name={"signatureFile"}
                onChange={handleChangeFileInput}
                placeholder={"Wzór podpisu"}
              />
              <div className={"border p-1 m-1"}>
                Podpis:
                <img
                  width={200}
                  src={signatureUrl}
                  title={"Podpis pracownika"}
                  alt={"wybierz plik jpg/png aby dodać podpis pracownika"}
                />
              </div>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button type={"submit"}>Zapisz</Button>
          </Modal.Footer>
        </Form>
      )}
    </Modal>
  );
}
